const ConditionsCard = ({ profile, feeLine }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="text-sm font-semibold text-secondary-900 mb-3">Условия</div>

        {profile.composition && (
            <div className="text-sm text-secondary-700">
                <div className="text-xs text-secondary-500 mb-1">Состав</div>
                <div>{profile.composition}</div>
            </div>
        )}

        {feeLine && (
            <div className="mt-4 text-sm text-secondary-700">
                <div className="text-xs text-secondary-500 mb-1">Гонорар</div>
                <div>{feeLine}</div>
            </div>
        )}
    </div>
);

export default ConditionsCard;
